export default __webpack_public_path__ + "static/media/3.00457f33.jpg";